<template>
  <div class="row mt-4 ms-1 me-1">
    <section-header>Objawy</section-header>
    <ul class="ps-5 pe-5 mt-2">
      <li v-for="symptom in symptoms" :key="symptom.id" class="symptom mt-2">
        {{ symptom.name }}
      </li>
    </ul>
  </div>
</template>
<script>
import SectionHeader from "@/components/fault-detail-components/SectionHeader";
export default {
  components: { SectionHeader },
  props: {
    symptoms: [],
  },
};
</script>
<style scoped>
.symptom {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}
</style>
